// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3lMPl","right":"Footer_right__JDbiP","buttons":"Footer_buttons__1Jqvi"};